export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15134.c3811ece.jpg";